import { Toast } from 'vuex-toast'

export default {
  components: { Toast }
}
